import React, { memo } from 'react';
import { Row, Col } from 'react-bootstrap';
import { mypage_url, staff_mypage_url } from '../Const';

interface Props {
  is_staff: boolean;
}

// マイページへ戻るボタンの特殊棚
const MypageReturn: React.FC<Props> = ({ is_staff }) => {
  // リンクをクリックした時のアクション
  const handleClick = () => {
    location.href = is_staff ? staff_mypage_url : mypage_url;
  };

  return (
    <Row className="row-left-button">
      <Col className={'text-left p-0'} xl={6} lg={6} md={6} sm={6} xs={12}>
        <a className="btn btn-xl btn-main-color sp-my-page-return" onClick={handleClick}>
          マイページへ
          <br className="d-lg-none d-md-none" />
          戻る
        </a>
      </Col>
      <Col xl={6} lg={6} md={6} sm={6} xs={12}></Col>
    </Row>
  );
};

export default memo(MypageReturn);
